import React from "react";

const TextInput = ({
  label,
  value,
  placeHolder,
  onChangeValue,
  type,
  isNumber,
}) => {
  const onChangeValueHandler = (e) => {
    let tx = e.target.value;
    onChangeValue(type, tx);
  };

  return (
    <div className="flex flex-row w-full justify-between p-6">
      <h1>{label}</h1>
      <input
        onChange={onChangeValueHandler}
        className="w-3/5 h-9 bg-whiteCardColor border-none outline-none px-2"
        type={!isNumber ? "text" : "number"}
        placeholder={placeHolder}
        value={value}
      />
    </div>
  );
};

export default TextInput;
